module.exports = __webpack_public_path__ + "img/new-mobile-post-facebook-footer.8c964373.jpg";